<template>
  <v-container fluid class="pa-0">
    <div id="map" class="map"></div>
    <i id="mapSpinner" class="fa fa-spinner fa-spin map-spinner"></i>
    <vue-draggable-resizable
      style="border: none; opacity: 0.8;"
      :resizable="false"
      :x="10"
      :h="70"
      :w="400"
      :z="1"
      :parent="true"
      :drag-handle="'.drag-handle'"
      class="hidden-xs-only"
    >
      <v-card outline class="mx-auto" style="top: 56px">
        <v-system-bar color="#e60085" class="drag-handle">
          <v-icon color="#fff">mdi-information-outline</v-icon>
          <span style="color: #fff">Legenda</span>
          <v-spacer></v-spacer>
          <div style="color: #fff">
            <v-btn text color="white" class="white--text" @click="dataTable = true">
              Lista
              <v-icon color="white">mdi-view-headline</v-icon>
            </v-btn>&nbsp;
            <input type="radio" id="PM25" value="PM25" v-model="selectedMeasurement" />&nbsp;
            <label for="one">PM2.5</label>
            &nbsp;&nbsp;
            <input
              type="radio"
              id="PM10"
              value="PM10"
              v-model="selectedMeasurement"
            />&nbsp;
            <label for="two">PM10</label>
          </div>
        </v-system-bar>
        <v-card-text class="ma-0 pa-0">
          <div class="prediction-slider-wrapper">
            <v-icon
              class="prediction-player"
              color="#e60085"
              @click="playPredictionAnimation()"
            >{{ predictionAnimation ? 'mdi-pause' : 'mdi-play' }}</v-icon>
            <input
              type="range"
              min="0"
              max="24"
              step="1"
              v-model.number="predictionLevel"
              class="prediction-slider float-left"
              v-on:change="switchPrediction()"
            />
            <div class="prediction-slider-value">
              {{ predictionLevel }} h
            </div>
            <div style="clear:both"></div>
          </div>
          <div v-html="legendPM25" style="display:flex; wdith: 100%; height: 30px;"></div>
        </v-card-text>
      </v-card>
    </vue-draggable-resizable>

    <v-card
      outline
      class="mx-auto d-sm-none"
      style="position: fixed;bottom: 0;width: 100%; z-index: 100"
    >
      <v-system-bar color="#e60085">
        <v-icon color="#fff">mdi-information-outline</v-icon>
        <span style="color: #fff">Legenda</span>
        <v-spacer></v-spacer>
        <div style="color: #fff">
          <v-btn text color="white" class="white--text" @click="dataTable = true">
            Lista
            <v-icon color="white">mdi-view-headline</v-icon>
          </v-btn>&nbsp;
          <input type="radio" id="PM25" value="PM25" v-model="selectedMeasurement" />&nbsp;
          <label for="one">PM2.5</label>
          &nbsp;&nbsp;
          <input
            type="radio"
            id="PM10"
            value="PM10"
            v-model="selectedMeasurement"
          />&nbsp;
          <label for="two">PM10</label>
        </div>
      </v-system-bar>
      <v-card-text class="ma-0 pa-0">
          <div class="prediction-slider-wrapper">
            <v-icon
              class="prediction-player"
              color="#e60085"
              @click="playPredictionAnimation()"
            >{{ predictionAnimation ? 'mdi-pause' : 'mdi-play' }}</v-icon>
            <input
              type="range"
              min="0"
              max="24"
              step="1"
              v-model.number="predictionLevel"
              class="prediction-slider float-left"
              v-on:change="switchPrediction()"
            />
            <div class="prediction-slider-value">
              {{ predictionLevel }} h
            </div>
            <div style="clear:both"></div>
          </div>
        <div v-html="legendPM25" style="display:flex; wdith: 100%; height: 30px"></div>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dataTable" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar color="#94a60d">
          <v-btn icon dark @click="dataTable = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title style="color:#fff">Jakość powietrza</v-toolbar-title>
        </v-toolbar>
        <v-simple-table dense fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Nazwa czujnika</th>
                <th class="text-left">PM25</th>
                <th class="text-left">PM10</th>
                <th class="text-left">Data ostatniego odczytu</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in sensorData.features" :key="item.properties.objectid">
                <td>{{ item.properties.name }}</td>
                <td :style="getPM25Style(item)">{{ item.properties.pm25.toFixed(0) }}</td>
                <td :style="getPM10Style(item)">{{ item.properties.pm10.toFixed(0) }}</td>
                <td>{{ new Date(item.properties.assessmentdatetime).toLocaleString() }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-dialog>
    <div id="popupPanel" class="popup-panel d-sm-none"></div>
  </v-container>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import "../tools/EasyButton";
import "../tools/icons/PredictionIcon";
import "../tools/icons/SensorIcon";
import "../tools/icons/ClusterIcon";
import "../tools/Map";
import L from "leaflet";
import SensorLimits from "../tools/SensorLimits";
import VueDraggableResizable from "vue-draggable-resizable";
import "leaflet.markercluster";
import "leaflet.locatecontrol";
import AirQualityPopupVue from "./AirQualityPopup.vue";
import AirQualityClusterPopupVue from "./AirQualityClusterPopup.vue";
export default {
  name: "airquality",
  components: { VueDraggableResizable },
  data() {
    return {
      polling: null,
      changeBouncer: null,
      map: null,
      sensorData: null,
      airsensorIcon: null,
      airSensorLayer: null,
      airSensorPredictionLayer: null,
      airSensorPredictionClusterLayer: null,
      airSensorClusterGroup: null,
      dataTable: false,
      predictionLevel: 0,
      predictionAnimation: false,
      predictionAnimationId: null,
      selectedMeasurement: "PM25"
    };
  },
  mounted() {
    this.loadIcons();
    this.initMap();
    this.loadData();
    this.pollData();
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  computed: {
    legendPM25() {
      let div = "";
      let gradesPM25 = [0, 13, 37, 61, 85, 121];
      let gradesPM10 = [0, 21, 61, 101, 141, 201];
      let grades = [];

      if (this.selectedMeasurement == "PM25") grades = gradesPM25;
      else grades = gradesPM10;

      for (var i = 0; i < grades.length; i++) {
        div +=
          "<div style='padding-top: 4px; padding-bottom:4px; display:inline-block; width: 100%; text-align:center; color:white;background-color:" +
          SensorLimits.getLimitColor(this.selectedMeasurement, grades[i] + 1) +
          ";'>" +
          grades[i] +
          (grades[i + 1] ? "&ndash;" + grades[i + 1] + "</div>" : "");
      }
      div += "</div>";
      return div;
    }
  },
  watch: {
    selectedMeasurement() {
      if (this.changeBouncer) clearTimeout(this.changeBouncer);
      this.changeBouncer = setTimeout(this.loadData, 250);
    },
    sensorData() {
      this.clearPredictionLayer();
      this.clearPredictionClusterLayer();

      if (this.predictionLevel > 0) {
        this.airSensorPredictionLayer = L.geoJson(this.sensorData, {
          pointToLayer: (feature, latlng) => {
            return L.marker(latlng, {
              opacity: 0.6,
              icon: L.predictionIcon({
                zoom: this.map.getZoom(),
                color: this.getPredictionColor(feature),
                className: "prediction-layer-icon",
                iconSize: [0, 0]
              })
            });
          }
        });
        this.airSensorClusterGroup.addLayer(this.airSensorPredictionLayer);
      }

      //clear air sensor layer
      if (this.airSensorLayer) {
        this.airSensorClusterGroup.removeLayer(this.airSensorLayer);
        this.airSensorLayer = null;
      }

      this.airSensorLayer = L.geoJson(this.sensorData, {
        pointToLayer: (feature, latlng) => {
          return L.marker(latlng, {
            icon: L.sensorIcon({
              color: this.getMarkerColor(feature),
              iconUrl: "/img/czujnik_powietrza.png",
              className: "air-div-icon",
              iconSize: [25, 25]
            })
          });
        },
        onEachFeature: (feature, layer) => {
          let that = this;
          let PopupCont = Vue.extend(AirQualityPopupVue);

          let sensorData = feature.properties;

          if (that.predictionLevel > 0) {
            sensorData["predictionHour"] = that.predictionLevel;
            sensorData["predictionPM10"] =
              sensorData["pm10h" + that.predictionLevel];
            sensorData["predictionPM25"] =
              sensorData["pm25h" + that.predictionLevel];
          }

          let popup = new PopupCont({
            propsData: {
              sensordata: feature.properties
            }
          });

          layer.on("click", function(e) {
            Map.showPopup(
              that.map,
              that.$vuetify.breakpoint.name,
              popup,
              e,
              function() {
                return that.calculateMarkerColor(feature);
              }
            );
          });
        }
      });
      this.airSensorClusterGroup.addLayer(this.airSensorLayer);
    }
  },
  methods: {
    playPredictionAnimation() {
      let that = this;

      if (that.predictionAnimationId !== null) {
        clearInterval(that.predictionAnimationId);
      }

      if (!that.predictionAnimation) {
        that.predictionAnimation = true;
        that.predictionAnimationId = setInterval(function() {
          if (that.predictionLevel < 24) {
            that.predictionLevel = that.predictionLevel + 1;
            that.refreshPredictionLayer();
          } else {
            if (that.predictionAnimationId !== null) {
              clearInterval(that.predictionAnimationId);
            }

            that.predictionLevel = 0;
            that.predictionAnimation = false;
            that.clearPredictionLayer();
            that.loadData();
          }
        }, 1150);
      } else {
        that.predictionLevel = 0;
        that.predictionAnimation = false;
        that.clearPredictionLayer();
        that.loadData();
      }
    },
    getMarkerColor(feature) {
      let markerColor = null;

      let pm25 = feature.properties.pm25;
      let pm10 = feature.properties.pm10;

      if (this.predictionLevel > 0) {
        markerColor = "none";
      } else {
        if (this.selectedMeasurement == "PM25") {
          markerColor = SensorLimits.getLimitColor("PM25", pm25);
        } else if (this.selectedMeasurement == "PM10") {
          markerColor = SensorLimits.getLimitColor("PM10", pm10);
        }
      }

      return markerColor;
    },
    getClusterNumber(cluster) {
      let markers = cluster.getAllChildMarkers();
      let result = 0;
      for (var i = 0; i < markers.length; i++) {
        if (
          markers[i].options.icon.options.className !== "prediction-layer-icon"
        ) {
          result += 1;
        }
      }
      return result;
    },
    getPredictionColor(feature) {
      let predictionColor = null;
      let pm25predicition = feature.properties["pm25h" + this.predictionLevel];
      let pm10predicition = feature.properties["pm10h" + this.predictionLevel];

      if (this.predictionLevel > 0) {
        if (this.selectedMeasurement == "PM25") {
          predictionColor = SensorLimits.getLimitColor("PM25", pm25predicition);
        } else if (this.selectedMeasurement == "PM10") {
          predictionColor = SensorLimits.getLimitColor("PM10", pm10predicition);
        }
      }

      return predictionColor;
    },
    getPredictionClusterColor(clusterData) {
      return this.calculateClusterMarkerColor(
        clusterData["avgPM25H" + this.predictionLevel],
        clusterData["avgPM10H" + this.predictionLevel]
      );
    },
    refreshPredictionLayer() {
      let that = this;
      if (
        this.airSensorPredictionLayer !== null ||
        this.airSensorPredictionClusterLayer !== null
      ) {
        if (this.airSensorPredictionLayer !== null) {
          this.airSensorPredictionLayer.eachLayer(function(l) {
            if (l instanceof L.Marker) {
              if (l.getIcon().isDomExists()) {
                l.getIcon().setColor(that.getPredictionColor(l.feature));
              }
            }
          });
        }

        if (this.airSensorPredictionClusterLayer !== null) {
          this.airSensorPredictionClusterLayer.eachLayer(function(l) {
            if (l instanceof L.Marker) {
              if (l.getIcon().isDomExists()) {
                l.getIcon().setColor(
                  that.getPredictionClusterColor(l.options.clusterData)
                );
              }
            }
          });
        }
      } else {
        this.loadData();
      }

      if (this.predictionLevel <= 0) {
        this.airSensorLayer.eachLayer(function(l) {
          if (l instanceof L.Marker) {
            l.getIcon().setColor(that.getMarkerColor(l.feature));
          }
        });
      }
    },
    clearPredictionLayer() {
      if (this.airSensorPredictionLayer) {
        this.airSensorClusterGroup.removeLayer(this.airSensorPredictionLayer);
        this.airSensorPredictionLayer = null;
      }
    },
    clearPredictionClusterLayer() {
      if (this.airSensorPredictionClusterLayer) {
        this.map.removeLayer(this.airSensorPredictionClusterLayer);
        this.airSensorPredictionClusterLayer = null;
      }
    },
    switchPrediction() {
      this.loadData();
    },
    getPM25Style(feature) {
      let style = "";

      if (this.selectedMeasurement === "PM25") {
        style = "color: " + this.calculateMarkerColor(feature);
      }

      return style;
    },
    getPM10Style(feature) {
      let style = "";

      if (this.selectedMeasurement === "PM10") {
        style = "color: " + this.calculateMarkerColor(feature);
      }

      return style;
    },
    calculateClusterData(cluster, calculatePredictives) {
      var children = cluster.getAllChildMarkers();

      //prepare init values
      var properties = (function() {
        let result = {};

        let initValues = {
          avg: 0,
          sum: 0,
          max: 0
        };

        //generate 24 properties for predictive values
        if (calculatePredictives) {
          for (var i = 1; i <= 24; i++) {
            let pm25hx = "pm25h" + i;
            let pm10hx = "pm10h" + i;

            result[pm25hx] = Object.assign({}, initValues);
            result[pm10hx] = Object.assign({}, initValues);
          }
        }

        //init values for pm25,pm10 (sum, avg, max)
        result["pm25"] = Object.assign({}, initValues);
        result["pm10"] = Object.assign({}, initValues);

        return result;
      })();

      //calculate aggregate(sum, avg, max) values
      for (var i = 0; i < children.length; i++) {
        for (const property in properties) {
          properties[property].sum += children[i].feature.properties[property];
          properties[property].avg = properties[property].sum / (i + 1);

          properties[property].max =
            properties[property].max > children[i].feature.properties[property]
              ? properties[property].max
              : children[i].feature.properties[property];
        }
      }

      //prepare result data
      let result = {};
      for (const property in properties) {
        result["sum" + property.toUpperCase()] = properties[property].sum;
        result["avg" + property.toUpperCase()] = properties[property].avg;
        result["max" + property.toUpperCase()] = properties[property].max;
      }

      return result;
    },
    calculateClusterMarkerColor(avgPM25, avgPM10) {
      let markerColor = "#58b109";

      let pm25 = avgPM25.toFixed(0);
      let pm10 = avgPM10.toFixed(0);

      if (pm25 > 13) markerColor = "#94a60d";
      if (pm10 > 21) markerColor = "#94a60d";
      if (pm25 > 37) markerColor = "#ffc900";
      if (pm10 > 61) markerColor = "#ffc900";
      if (pm25 > 61) markerColor = "#edb238";
      if (pm10 > 101) markerColor = "#edb238";
      if (pm25 > 85) markerColor = "#e60008";
      if (pm10 > 141) markerColor = "#edb238";
      if (pm25 > 121) markerColor = "#990a0f";
      if (pm10 > 201) markerColor = "#990a0f";

      return markerColor;
    },
    calculateMarkerColor(feature) {
      let markerColor = "";
      let pm25 = feature.properties.pm25;
      let pm10 = feature.properties.pm10;

      if (this.selectedMeasurement == "PM25") {
        markerColor = SensorLimits.getLimitColor("PM25", pm25);
      } else if (this.selectedMeasurement == "PM10") {
        markerColor = SensorLimits.getLimitColor("PM10", pm10);
      }

      return markerColor;
    },
    close(e) {
      console.log(e);
    },
    getColorPM(pm25, pm10) {
      let markerColor = "#58b109";
      if (pm25 > 13) markerColor = "#94a60d";
      if (pm10 > 21) markerColor = "#94a60d";
      if (pm25 > 37) markerColor = "#ffc900";
      if (pm10 > 61) markerColor = "#ffc900";
      if (pm25 > 61) markerColor = "#edb238";
      if (pm10 > 101) markerColor = "#edb238";
      if (pm25 > 85) markerColor = "#e60008";
      if (pm10 > 141) markerColor = "#edb238";
      if (pm25 > 121) markerColor = "#990a0f";
      if (pm10 > 201) markerColor = "#990a0f";
      return markerColor;
    },
    loadIcons() {
      this.airsensorIcon = new L.Icon({
        iconUrl: "/img/czujnik_powietrza.png",
        iconSize: [21, 21],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34]
      });
    },
    pollData() {
      this.polling = setInterval(() => {
        this.loadData();
      }, 60000);
    },
    loadData() {
      let spinner = document.getElementById("mapSpinner");
      spinner.style.display = "block";

      let constraints = Map.getConstraints(this.map);
      axios
        .get("/IOCNext/api/spatial/aq_sensors", {
          params: {
            boundaries: constraints
          }
        })
        .then(response => {
          this.sensorData = response.data;
          let spinner = document.getElementById("mapSpinner");
          spinner.style.display = "none";
        })
        .catch(error => console.log("ERROR line 312: " + error));
    },
    initMap() {
      let that = this;

      this.map = Map.initMap(50.222894, 19.026368, 12);
      Map.addTile(this.map);
      Map.addZoomControl(this.map);
      Map.addLocateControl(this.map);

      //load city boundaries
      axios
        .get("/KatowiceSmall.geojson", {})
        .then(response => {
          console.log("borders receivied");
          var citiBoundaries = new L.geoJSON(response.data, {
            style: { fillOpacity: 0.1 }
          }).addTo(this.map);
        })
        .catch(error => console.log(error));

      //init cluster groups
      this.airSensorClusterGroup = L.markerClusterGroup({
        spiderfyOnMaxZoom: false,
        showCoverageOnHover: false,
        zoomToBoundsOnClick: false,
        maxClusterRadius: 40,
        disableClusteringAtZoom: 13,
        iconCreateFunction: function(cluster) {
          if (that.predictionLevel > 0) {
            if (!that.airSensorPredictionClusterLayer) {
              that.airSensorPredictionClusterLayer = L.layerGroup();
              that.map.addLayer(that.airSensorPredictionClusterLayer);
            }

            let latlng = L.latLng(cluster._latlng.lat, cluster._latlng.lng);
            let clusterData = that.calculateClusterData(cluster, true);

            that.airSensorPredictionClusterLayer.addLayer(
              L.marker(latlng, {
                opacity: 0.6,
                clusterData: clusterData,
                icon: L.predictionIcon({
                  zoom: that.map.getZoom(),
                  color: that.getPredictionClusterColor(clusterData),
                  className: "prediction-layer-icon",
                  iconSize: [0, 0]
                })
              })
            );
          }

          let clusterColor = "none";
          if (that.predictionLevel <= 0) {
            let clusterData = that.calculateClusterData(cluster, false);
            clusterColor = that.calculateClusterMarkerColor(
              clusterData.avgPM25,
              clusterData.avgPM10
            );
          }

          return new L.clusterIcon({
            color: clusterColor,
            number: that.getClusterNumber(cluster),
            className: "air-div-icon",
            iconSize: [38, 38]
          });
        }
      });

      //define cluster click event
      this.airSensorClusterGroup.on("clusterclick", function(e) {
        let PopupCont = Vue.extend(AirQualityClusterPopupVue);

        let clusterData = that.calculateClusterData(e.layer, true);
        let sensorData = {
          maxPM10: clusterData.maxPM10,
          maxPM25: clusterData.maxPM25,
          avgPM10: clusterData.avgPM10,
          avgPM25: clusterData.avgPM25
        };

        if (that.predictionLevel > 0) {
          sensorData["maxPredictionPM10"] =
            clusterData["maxPM10H" + that.predictionLevel];
          sensorData["maxPredictionPM25"] =
            clusterData["maxPM25H" + that.predictionLevel];

          sensorData["avgPredictionPM10"] =
            clusterData["avgPM10H" + that.predictionLevel];
          sensorData["avgPredictionPM25"] =
            clusterData["avgPM25H" + that.predictionLevel];
          sensorData["predictionHour"] = that.predictionLevel;
        }

        let popup = new PopupCont({
          propsData: {
            sensordata: sensorData
          }
        });

        Map.showPopup(
          that.map,
          that.$vuetify.breakpoint.name,
          popup,
          e,
          function() {
            return that.calculateClusterMarkerColor(
              clusterData.avgPM25,
              clusterData.avgPM10
            );
          }
        );
      });

      this.map.addLayer(this.airSensorClusterGroup);
      this.map.on("moveend", () => {
        if (this.changeBouncer) clearTimeout(this.changeBouncer);
        this.changeBouncer = setTimeout(this.loadData, 1150);
      });
    }
  }
};
</script>

<style>
.verygood {
  background-image: url("/img/gradients/verygood.png");
}

.good {
  background-image: url("/img/gradients/good.png");
}

.moderate {
  background-image: url("/img/gradients/moderate.png");
}

.sufficient {
  background-image: url("/img/gradients/sufficient.png");
}

.bad {
  background-image: url("/img/gradients/bad.png");
}

.verybad {
  background-image: url("/img/gradients/verybad.png");
}

.cluster-verygood {
  background-image: url("/img/gradients/cluster_verygood.png");
}

.cluster-good {
  background-image: url("/img/gradients/cluster_good.png");
}

.cluster-moderate {
  background-image: url("/img/gradients/cluster_moderate.png");
}

.cluster-sufficient {
  background-image: url("/img/gradients/cluster_sufficient.png");
}

.cluster-bad {
  background-image: url("/img/gradients/cluster_bad.png");
}

.cluster-verybad {
  background-image: url("/img/gradients/cluster_verybad.png");
}

.prediction-layer-icon {
  background-color: #fff;
  cursor: crosshair;
}

.prediction-player {
  float: left;
  background-color: #ff8fd0;
}

.prediction-slider {
  -webkit-appearance: none;
  float: left;
  width: 100%;
  height: 22px;
  background: #ff8fd0;
  outline: none;
}

.prediction-slider-wrapper {
  display:flex;
  width: 100%;
  height: 24px;
  border-top: 1px solid #ffffff;
  border-bottom: 1px solid #ffffff;
}

.prediction-slider-value {
  display:inline-block;
  width: 100px;
  text-align:center;
  color:#e60085;
  background-color: #ff8fd0;
  font-weight: bold;
}

.prediction-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 22px;
  height: 22px;
  background: #e60085;
  border: none;
  cursor: pointer;
}

.prediction-slider::-moz-range-thumb {
  width: 22px;
  height: 22px;
  background: #e60085;
  cursor: pointer;
  border: none;
}

#map {
  height: 100vh;
  width: 100%;
  z-index: 1;
}
.air-div-icon {
  border: none;
  background-color: transparent;
}

.leaflet-control-zoom-in {
  background-color: #e60085 !important;
  color: #ffffff !important;
  border: none !important;
  border-radius: 0px !important;
}

.leaflet-control-zoom-out {
  background-color: #e60085 !important;
  color: #ffffff !important;
  border: none !important;
  border-radius: 0px !important;
  margin-top: 5px;
}

.leaflet-bar-part-single {
  background-color: #e60085 !important;
  color: #ffffff !important;
  border: none !important;
  border-radius: 0px !important;
}

.leaflet-control-zoom {
  border: none !important;
  border-radius: 0px !important;
  margin-top: 5em !important;
}

.leaflet-bar {
  border: none !important;
  border-radius: 0px !important;
}

.popup-panel {
  position: fixed;
  bottom: 78px;
  width: 100%;
  height: auto;
  background-color: #fff;
  z-index: 500;
  display: none;
  overflow: hidden;
}

.popup-panel-pointer {
  position: fixed;
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 20px solid transparent;
  left: 50%;
  margin-left: -16px;
  margin-top: -20px;
  z-index: 500;
}

.v-dialog__content {
  z-index: 700 !important;
}

.map-spinner {
  position: fixed;
  left: 50%;
  top: 50%;
  margin-left: -40px;
  margin-top: -80px;
  font-size: 80px;
  color: #e60085;
  z-index: 600;
  display: none;
  opacity: 0.5;
}
</style>
